import { useDispatch } from "react-redux";
import { deleteAllImages } from "store/features/bulkResize/actions";

export const useDelete = () => {
    const dispatch = useDispatch();

    const handleDelete = () => dispatch(deleteAllImages());

    return { handleDelete };
};
